import Button from "@components/common/Button.component";
import { useNavigate } from "react-router-dom";


const EmeraldCityInfo = () => {
  const navigate = useNavigate();
  return (
    <div className="ecp-info-wrapper">
      <p className="ecp-info-text adjust-font ">
        Emerald City is the first virtual city to be launched as part of the GangstaVerse. The Emerald City will be a gateway for the ICON community to a next-gen DeFi game that embraces the full potential of blockchain, with a compelling storyline, sophisticated NFTs with both collectible and gaming properties utilizing several DeFi components.
      </p>
      <br />
      <p className="ecp-info-text adjust-font ">
        Our vision is to build community-owned & community-led cities of gangsters and detectives with vibrant economies.
      </p>
      <br />
      <Button onClick={() => window.open("https://gangstabet.medium.com/introducing-the-emerald-city-827b14e9757a")}>
        Learn More
      </Button>

      <div className="ytp-video">
        <iframe
          src="https://www.youtube.com/embed/dg8hclFntDw"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          width={"100%"}
          className="yt-video-frame"
        ></iframe>
      </div>
    </div>
  );
};
export default EmeraldCityInfo;
